import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import store from "../../../../../store/index";
import { setZoomToElementId } from "../../../../../store/actions/Store";



const selectionFillColor = 'DeepSkyBlue';
const selectionStrokeColor = 'RoyalBlue';

const selectionLayerId = 'SelectionLayer';
const selectionRectId = 'SelectionElement';

const getFloorMousePosition = (event, floorNode, w, d) => {
  const bounds = floorNode.getBoundingClientRect();

  const scaleX = w / bounds.width;
  const scaleY = d / bounds.height;
  const mouseX = (event.clientX - bounds.left) * scaleX;
  const mouseY = (event.clientY - bounds.top) * scaleY;

  return { x: mouseX, y: mouseY };
};

/**
* Calculate selected area for zoom
* Retrieve data (x, y, width, height) by attribute name
* 
* @param {string} attribute 
* @returns {Object}
*/
const getRect = (p1, p2) => {
  const rect = { x: 0, y: 0, width: 0, height: 0 };
  if (p1 && p2) {
      rect.x = (p1.x < p2.x ? p1.x : p2.x);
      rect.y = (p1.y < p2.y ? p1.y : p2.y);
      rect.width = (p1.x < p2.x ? p2.x - p1.x : p1.x - p2.x);
      rect.height = (p1.y < p2.y ? p2.y - p1.y : p1.y - p2.y);
  }
  return rect;
};

const SelectionLayer = ({ scale = 1, onSelectStart, onSelectEnd }) => {
  const [selecting, setSelecting] = useState(false);

  const [posStart, setPosStart] = useState(null);
  const [posEnd, setPosEnd] = useState(null);
  const [posCurr, setPosCurr] = useState(null);

  const isWallDrawEnabled = useSelector((state) => state.store.isWallDrawEnabled);
  const storeData = useSelector((state) => state.store.storeData);

  const st = storeData?.floor_plan; // store
  const width = st?.width;
  const depth = st?.depth;

  const svgRef = useRef();

  const onMouseDown = (event) => {
    if (!selecting || isWallDrawEnabled) return;

    const pos = getFloorMousePosition(event, svgRef.current, width, depth);
    setPosStart(pos);
    setPosCurr(null);
    setPosEnd(null);

    if (onSelectStart) onSelectStart();
  };

  const onMouseMove = (event) => {
    if (!selecting || isWallDrawEnabled) return;

    const pos = getFloorMousePosition(event, svgRef.current, width, depth);
    setPosCurr(pos);
  };

  const onMouseUp = (event) => {
    if (!selecting || isWallDrawEnabled) return;
    
    const pos = getFloorMousePosition(event, svgRef.current, width, depth);
    setPosEnd(pos);

    if (onSelectEnd) onSelectEnd();
  };

  useEffect(() => {
    const onKeyDownCtrl = (event) => {
      if (event.key === "Control") {
        setPosStart(null);
        setPosCurr(null);
        setPosEnd(null);
        setSelecting(true);
      }
    };

    const onKeyUpCtrl = (event) => {
      if (event.key === "Control") {
        setSelecting(false);
      }
    };

    window.addEventListener('keydown', onKeyDownCtrl);
    window.addEventListener('keyup', onKeyUpCtrl);

    return () => {
      window.removeEventListener('keydown', onKeyDownCtrl);
      window.removeEventListener('keyup', onKeyUpCtrl);
    }
  }, []);

  useEffect(() => {
    if (posStart && posEnd) {
      store.dispatch(setZoomToElementId(selectionRectId));
      // setPosStart(null);
      // setPosEnd(null);
    }
  }, [posStart, posEnd]);

  // TODO: move to selection layer
  const rect = getRect(posStart, posEnd || posCurr);

  return (
    <svg
      ref={svgRef}
      id={selectionLayerId}
      width={width}
      height={depth}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      style={{
        position: 'absolute',
        zIndex: selecting ? 1 : 'auto', // pops over elements layer
      }}
    >
      <rect
        visibility={selecting ? 'visible' : 'hidden'}
        id={selectionRectId}
        x={rect.x}
        y={rect.y}
        width={rect.width}
        height={rect.height}
        fill={selectionFillColor}
        fillOpacity={0.1}
        stroke={selectionStrokeColor}
        strokeWidth={1/scale}
        strokeDasharray={3/scale}
      />
    </svg>
  );
};

export default SelectionLayer;
